import { API, BASE_URL_AI, axiosClient } from "../../../Constant/apiConstant";

export const pauseGatewayService = async (gatewayName, obj) => {
  const res = await axiosClient.post(
    `${BASE_URL_AI}${API.V1.AI.PAUSE_GATEWAY}/${gatewayName}`,
    obj
  );
  return res;
};

export const setPooledAiGatewayService = async (gatewayName, obj) => {
  const res = await axiosClient.post(
    `${BASE_URL_AI}${API.V1.AI.POOLED_AI_GATEWAY}/${gatewayName}`,
    obj
  );
  return res;
};

export const pauseServerService = async (obj) => {
  try {
    const res = await axiosClient.post(
      `${BASE_URL_AI}${API.V1.AI.PAUSE_SERVER}`,
      obj
    );
    return res?.data;
  } catch (err) {
    console.error("Error pausing server:", err);
    throw err;
  }
};

export const getServerDetailsService = async (params) => {
  try {
    const res = await axiosClient.get(
      `${BASE_URL_AI}${API.V1.AI.SERVER_DETAILS}`,
      {
        params: params,
      }
    );
    return res;
  } catch (err) {
    console.error("Error :", err);
    throw err;
  }
};
